import { updateUser } from '../profile/api';

export const addMessagingTokenToUser = async (messageToken, userUid) => {
  messageToken
    .then(currentToken => {
      if (currentToken) {
        updateUser(userUid, { messageToken: currentToken });
        // Send the token to your server and update the UI if necessary
        // ...
      } else {
        // Show permission request UI
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            messageToken.then(tkn => {
              if (tkn) {
                updateUser(userUid, { messageToken: tkn });
              }
            });
            console.log(
              'No registration token available. Request permission to generate one.',
            );
          }
        });
        // ...
      }
    })
    .catch(err => {
      console.log('An error occurred while retrieving token. ', err);
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          messageToken.then(tkn => {
            if (tkn) {
              updateUser(userUid, { messageToken: tkn });
            }
          });
          console.log(
            'No registration token available. Request permission to generate one.',
          );
        }
      });
    });
};
